import React from 'react';

const UploadInput = ({
  file,
  onDrop,
  onDragOver,
  onDragEnter,
  onDragLeave,
  onFileSelected
}) => (
  <div
    className="drag-drop-wrapper"
    onDrop={onDrop}
    onDragOver={onDragOver}
    onDragEnter={onDragEnter}
    onDragLeave={onDragLeave}
  >
    {!file && (
      <div className="icon">
        <i className="fa fa-cloud-upload" aria-hidden="true"></i>
      </div>
    )}
    {file && (
      <>
        <div className="icon">
          <i className="fa fa-file-code-o" aria-hidden="true"></i>
        </div>
        <div className="file-name">
          <span>{file.name}</span>
        </div>
      </>
    )}
    <div className="text">
      <span>Drag and Drop an OPML file here</span>
    </div>
    <div className="text or">
      <span>OR</span>
    </div>
    <div className="button-oval button-signin24 button-cta2-24 button-width24 ">
      <label className="button-oval button-signin24 button-cta2-24 button-width24" htmlFor="pdfFile">
        Browse
        <input
          id="pdfFile"
          type="file"
          accept=".pdf,.txt,.rtf,.docx"
          className="file-input"
          onChange={onFileSelected}
        />
      </label>
    </div>
  </div>
);

export default React.memo(UploadInput);
